import React, { useEffect, useState } from "react";
import BlogCard from "../components/BlogCard";
import { Link } from "react-router-dom";

const BLOG_API =
  "https://script.google.com/macros/s/AKfycbwmB7z0yq-ZZ0XACM5xUanfOu8inX0RSQ9DBbDqZuwftlDeoXbaphtqFg2VgdB7tqnr/exec?type=blogs";

function BlogList() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(BLOG_API)
      .then((res) => res.json())
      .then((data) => {
        setBlogs(data.blogs || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="section">
        <Link to="/" className="back-home">← Back to Home</Link>

      <h1>Toyco Blog</h1>
      <p>Guides, tips and insights from 10+ years in the toy industry.</p>

      {loading && <p>Loading blogs…</p>}

      <div className="blog-grid">
        {blogs.map((blog) => (
          <BlogCard key={blog.slug} blog={blog} />
        ))}
      </div>
    </div>
  );
}

export default BlogList;
